import { TopContainer, TipsToReduce, ReceiveResult, ActionButtons } from './components';
import styled from 'styled-components/macro';
import { useEffect, useState } from 'react';
import { Co2FootprintVO } from 'vo';
import { CalculatorFormValues, Co2FootprintsVOs } from 'common/types';
import { useCo2FootprintPerAttendeVOs } from 'hooks/useCo2FootprintPerAttendeVOs';
import { Pictogram } from '@net0-calc/common/assets/svg';
import { DEVICE } from '@net0-calc/common/assets/styles';
import { METHODOLOGY_PDF_LINK } from 'common/constants/file-links';
import { DownloadMethodology } from '@net0-calc/common/components';

type Props = {
  formValues: CalculatorFormValues;
  co2FootprintSumVO: Co2FootprintVO;
  co2FootprintsVOs: Co2FootprintsVOs;
  answerId?: string;
};

export const Result = ({ formValues, answerId = '', co2FootprintSumVO, co2FootprintsVOs }: Props) => {
  const co2FootprintPerAttendeVOs = useCo2FootprintPerAttendeVOs(formValues, co2FootprintsVOs);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <Root>
      <StyledDownloadMethodology />
      <TopContainer
        eventName={formValues.eventName || 'Unknown'}
        co2FootprintSumVO={co2FootprintSumVO}
        co2FootprintsVOs={co2FootprintsVOs}
        co2FootprintPerAttendeVOs={co2FootprintPerAttendeVOs}
      />
      <TipsToReduce answerId={answerId} />
      <DesktopActionsWrapper>
        <ActionButtons
          formValues={formValues}
          co2FootprintSumVO={co2FootprintSumVO}
          co2FootprintsVOs={co2FootprintsVOs}
          answerId={answerId}
        />
      </DesktopActionsWrapper>
      <ReceiveResult answerId={answerId} />
      <MobileActionsWrapper>
        <ActionButtons
          formValues={formValues}
          co2FootprintSumVO={co2FootprintSumVO}
          co2FootprintsVOs={co2FootprintsVOs}
          answerId={answerId}
        />
      </MobileActionsWrapper>
      <PictogramContainer>
        <Pictogram idPrefix="big" />
      </PictogramContainer>
      <CertificateImageContainer onClick={() => window.open(METHODOLOGY_PDF_LINK)}>
        <img src="https://net0.s3.amazonaws.com/net0-cert.png" alt="Verified by Net0" />
      </CertificateImageContainer>
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 25px;

  @media ${DEVICE.laptop} {
    padding-bottom: 50px;
  }
`;

const PictogramContainer = styled.div`
  display: flex;
  justify-content: center;

  & > svg {
    height: 54px;
  }

  @media ${DEVICE.laptop} {
    padding-top: 70px;
    margin-top: auto;

    & > svg {
      height: 81px;
    }
  }
`;

const CertificateImageContainer = styled.div`
  position: absolute;
  right: 50%;
  transform: translateX(50%);
  padding: 20px 0 50px;
  cursor: pointer;

  & > img {
    width: 62px;
    height: 62px;
  }

  @media ${DEVICE.laptop} {
    right: 0;
    bottom: 50px;
    padding: 0;
    padding-right: 80px;

    & > img {
      width: 100px;
      height: 100px;
    }
  }
`;

const DesktopActionsWrapper = styled.div`
  display: none;

  @media ${DEVICE.laptop} {
    display: block;
  }
`;

const MobileActionsWrapper = styled.div`
  display: block;
  & > div {
    margin-bottom: 25px;
  }

  @media ${DEVICE.laptop} {
    display: none;
  }
`;

const StyledDownloadMethodology = styled(DownloadMethodology)`
  width: 100%;
  margin-bottom: 20px;

  @media ${DEVICE.laptop} {
    display: none;
  }
`;
